export default {
	global: {
		bookings: 'Bookings',
		rates: 'Rates',
		design: 'Design',
		settings: 'Settings',
		successUpdate: 'Successful update',
		changeOf: 'Change of {system}',
		clicToSwitch: 'Click to switch to this',
		changePlatform: 'Change platform',
		back: 'Back',
		selectSystem: 'Select point of sale',
		saveChanges: 'Save changes',
		updatedConfigurations: 'Updated configurations',
		close: 'Close',

		open: 'Open',
		loading: 'Loading...',


		operation: 'Operation',
		operationAssignment: 'Assignment',
		operationTracking: 'Tracking',
		transportUnits: 'Fleet',
		users: 'Users',
		drivers: 'Drivers',
		profile: 'Profile',
		logout: 'Logout',
		all: 'All',
		selectAll: 'Select all',
		clean: 'Clean',
		search: 'Search',
		firstName: 'First Name',
		lastName: 'Last Name',
		save: 'Save',
		yes: 'Yes',
		filters: 'Filters',
		registerDeleted: 'Deleted successfully',
		serverError: 'The server no response',
		ajaxTable: {
			noRecordsFound: 'No records found',
			selectAll: 'Select All',
			showingNRecords: 'Showing {from} to {to} records of {total}',
			massiveOperationsOn: 'Enable bulk operations',
			massiveOperationsOff: 'Disable bulk operations',
			assignConfirmation: 'Assign confirmation',
		},
		status: 'Status',
		actions: 'Actions',
		copy: 'Copy',
		minutes: 'minutes',
		after: 'after',
		before: 'before',
		ofFlight: 'flight',
		delete: 'Delete',
		add: 'Add',
		phone: 'Phone',
		email: 'Email',
		cancel: 'Cancel',
		update: 'Update',
		description: 'Description',
		change: 'Change',
		upload: 'Upload',
		info: 'Information',
		image: 'Image',
		pos: 'POS',
		selectOption: 'Select an option',
		supplier: 'Supplier',
		pointOfSale: 'Point Of Sale',
	},
	warnings: {
		okToContinue: 'Confirm action',
		continue: 'Continue',
		cancel: 'Cancel',
		processing: 'Processing',
		switchSystem: 'Are you sure you want to switch systems?',
		selectValidSystem: 'Select a valid system',
		errorOccurred: 'An error occurred, please try again later',
		desactivateRate: 'Do you want to desactivate this rate?',
		noteRemoved: 'Note removed',
		resCancelled: 'Reservation successfully cancelled',
		noNegativeHours: 'Negative hours cannot be set.',

		offlinePOS: 'Your Point of Sale is offline, you cannot add reservations.',
		liveUnverifiedEmail: 'To change the status, you must first confirm your email',
		changeStatusPOS: 'Are you sure you want to change the status of your point of sale? This could affect future reservations.',

		sharedOutTime: 'The shared service only operates from 9:00 a.m. to 7:00 p.m.',
		cutoff: 'Is your service in less than 24 hours? send us a whatsapp to +5219982912922',
	},
	bookings: {
		warningApiReservationPayment: 'If the service is not paid within the first 24 hours in which a payment link was created, it will be automatically canceled.',
		exporting: 'Exporting...',
		reservation: 'Reservation',
		reservationCreatedBy: 'Reservation created by',
		costs: 'Costs',
		notifications: 'Notifications',
		scheduleNotAvailable: 'The schedule is not available',
		updated: 'Updated',
		showBilling: 'Show billing information',
		billingInformation: 'Billing information',
		successNewReservation: 'Reservation successfully registered',
		alertCancelReservation: 'The reservation will be <strong>cancelled</strong> and it will not be possible to reactivate it.',
		newNote: 'New note',
		statusEvidence: 'Status evidence',
		evidence: 'Evidence',
		flightValidatedBy: 'The flight has been validated by ',
		manualFlightValidation: 'Manual flight validation',
		flightInfo: 'Flight data',
		flightNumberNotValid: 'Flight number is not valid',
		confirmedReservation: 'Reservation confirmed',
		editedReservation: 'Reservation edited',
		calculate: 'Calculate',
		transferTime: 'Transfer time',
		preFlightTime: 'Pre-flight time:',
		serviceCreatedBy: 'Service created by: ',
		contact: 'Contact',
		paymentStatus: 'Payment status',
		clientNotes: 'Customer notes',
		serviceWillUpdateStatus: 'The service will be updated to ',
		copyLink: 'Copy link',
		passengers: 'Passengers',
		notAccepted: 'Pending',
		clientName: 'Client name',
		airports: 'Airports',
		general: 'General',
		destinations: 'Destinations',
		salesReference: 'Sales channel ID',
		supplierConfirmed: 'Confirmed Service',
		referenceId: 'Supplier confirmation',
		serviceType: 'Service type',
		serviceStatus: 'Service status',
		pickupConfirmed: 'Pickup confirmed',
		serviceDateFrom: 'Service date from',
		serviceDateTo: 'Service date to',
		transportUnit: 'Vehicle',
		driver: 'Driver',
		trackingStatus: 'Tracking status',
		bookingDatetime: 'Booking date',
		bookingDateFrom: 'Booking date from',
		bookingDateTo: 'Booking date to',
		serviceStatusOpts: {
			active: 'Active',
			pending: 'Pending',
			noShow: 'No Show',
			noProvided: 'Not provided',
			canceled: 'Cancelled',
			done: 'Done',
			partialCancellation: 'Partial Cancellation',
		},
		trackingStatusOpts: {
			pending: 'Pending',
			onWayToPickup: 'On way to pickup',
			atPickup: 'At pickup',
			onWayToDropoff: 'On way to dropoff',
			finished: 'Finished',
			noShow: 'No show',
		},
		reservationStatusOpts: {
			active: 'Active',
			canceled: 'Cancelled',
		},
		confirmed: 'Confirmed',
		noConfirmed: 'No confirmed',
		cancelDateFrom: 'Cancelation date from',
		cancelDateTo: 'Cancel date to',
		tripType: 'Trip type',
		client: 'Client',
		pickupDate: 'Pickup date',
		trip: 'Trip',
		actions: 'Actions',
		export: 'Export',
		booking: 'Booking',
		clientInfo: 'Client info',
		adults: 'Adults',
		kids: 'Childrens',
		infants: 'Infants',
		service: 'Service',
		status: 'Status',
		origin: 'Origin',
		destination: 'Destination',
		route: 'Route',
		dateTimeAndNumberOf: '<strong>{flightLabel}</strong> date, time and flight number',
		arrivalFlight: 'Arrival Flight',
		departureFlight: 'Departure Flight',
		pickupDatetime: 'Pickup date & time',
		confirmData: 'Confirm data',
		before: 'before',
		after: 'after',
		supplierNotes: 'Supplier notes',
		flight: 'flight',
		minutes: 'minutes',
		serviceUpdatedSuccessfully: 'Service Updated Successfully',
		noShowEvidences: 'No Show evidences',
		noShowEvidenceMessage: 'To change the service status to <strong>NO SHOW</strong>, please upload the corresponding proofs, which show that the driver and / or staff is at the scheduled time and pick-up location.',
		doneEvidenceMessage: 'To change the service status to <strong>DONE</strong>, please upload the corresponding proofs, which show that the driver and / or staff is at the scheduled time and pick-up location.',
		accepted: 'Accepted',
		shuttleCentralService: 'Shuttle Central B2B',
		selfService: 'Direct sell',
		rejectService: 'Reject service',
		notes: 'Notes',
		salesChannel: 'Sales Channel',
		salesChannelReference: 'Sales Channel Reference',
		noShow: 'No Show',
		noProvided: 'Not Provided',
		cancel: 'Cancel',
		done: 'Done',
		partialCancellation: 'Partial Cancellation',
		confirm: 'Confirm',
		copyRes: 'Copy booking',
		createdBy: 'Created by',
		reservationDate: 'Booking date',
		canceledBy: 'Cancelled by',
		cancelationDate: 'Cancelation date',
		validate: 'Validate',
		addService: 'Add service',
		cancelRes: 'Cancel booking',
		acceptService: 'Accept service',
		servicesFrom: 'Services from',
		servicesTo: 'to',
		clickFlightInfo: 'Clic to see flight information',
		flightNotValidate: 'Flight not validate',
		newRes: 'New Booking',
		paxes: 'Passengers',
		pickup: 'Origin',
		dropoff: 'Destination',
		transportInfo: 'Service info',
		makeBooking: 'Book',
		Accepted: 'Accepted Rides',
		AcceptedOptions: {
			all: 'All',
			pending: 'Pending to confirm',
			confirmed: 'Confirmed'
		},
		AcceptedOptionsMassive: {
			rejected: 'Reject',
			confirmed: 'Confirm'
		},
		asignMsgPartial: "$TOTAL services could not be updated as they were previously accepted. If you require additional attention please contact the operations staff",
		asignMsg: 'Successful upgrade',
		emptyStateSelect: 'No state selected.',
		acceptReject: "Accept/Reject service",
		confirmAcceptService: "Are you sure you want to CONFIRM the service?",
		confirmRejectService: "Are you sure you want to REJECT the service?",
		selectServiceMassive: "No service selected",
		confirmSupplierConfirmationMassive: "Are you sure you want to %{action} the selected services?",
		assignDriverUnit: 'Driver & vehicle assigment',
		assign: 'Assign',
		unassignedServices: 'UNASSIGNED services',
		assignedServices: 'Assigned services',
	},
	users: {
		resetPassword: "Reset password",
		newPassword : 'New Pasword',
		repeatPassword : 'Repeat Password',
		updatedPassword : 'Updated Password',
		passwordAreDifferent : 'Password are different',
		newUser: 'New user',
		newDriver: 'New driver',
		name: 'Name',
		email: 'Email',
		access: 'Access',
		status: 'Status',
		actions: 'Actions',
		editingUser: 'Editing user',
		editingDriver: 'Editing driver',
		firstName: 'First name',
		lastName: 'Last name',
		phone: 'Phone',
		userInfo: 'User info',
		language: 'Language',
		accessTypeOpts: {
			master: 'Master',
			admin: 'Admin',
			operation: 'Operation',
			driver: 'Driver',
		},
		license: 'License',
		profilePicture: 'Profile picture',
		profile: 'Profile',
		msgRegistered: 'User added successfully',
		msgUpdate: 'User updated successfully',
		msgRemoved: 'User deleted successfully',
		password: 'Password',
	},
	payments: {
		payments: 'Payments',
		noPayment: 'No payment has been made for this reservation.',
		totalReserve: 'Total reserve',
		totalPaid: 'Total paid',
		totalPayable: 'Total payable',
		reference: 'Payment reference',
		cardHolder: 'Cardholder',
		cardType: 'Card type',
		last4: 'Last 4 digits',
		total: 'Total',
		date: 'Date',
		status: 'Status',
		totalEngine: 'Total engine',
		currency: 'Payment currency',
		creationDateTime: 'Date',
		user: 'User',

		selectCurrency: 'Select currency',
		selectCurrencyDesc: 'Only services with this currency can be selected.',
		expiredDate: 'Expiration date',
		hour: 'Time',
		serviceInAnotherPayReq: 'This service is selected in another payment request',
		serviceNumber: 'Service number',
		salesChannel: 'Sales channel',
		tripType: 'Type of trip',
		successPay: 'Payment was successfully added',
		currencyReq: 'Currency is required',
		expiredDateReq: 'Expiration date and time is required',
		serviceReq: 'Select at least one service',
		serviceAmountReq: 'Select at least one service with total greater than 0',
		paymentStatus: 'Payment status',

		newPayment: 'Add payment',
		showDetails: 'View details',
		transactions: 'Transactions',
		ridesToPay: 'Trips to be paid',
		cancel: 'Cancel',
		notifications: 'Notifications',
		copy: 'Copy',
		goToLink: 'Go to payment link',
		hideDetails: 'Hide details',
		paymentForm: 'Payment Form',
		details: 'Details',
		id: 'Id',
		created: 'Created',
		expiration: 'Expiration',
		sureCancelPayment: 'Are you sure you want to cancel the payment #{paymentId}? You will not be able to reactivate it again',
		confirm: 'Confirmation',
		yes: 'Yes',
		paymentCanceled: 'Payment was successfully cancelled #{paymentId}',
		canceled: 'Cancelled',
		paid: 'Paid',

		salesPrices: 'Sales prices',
		bookingPrice: 'Booking price',
		totalWithTaxes: 'Total with taxes',
		totalWithoutTaxes: 'Total without taxes',

	},
	profile: {
		firstName: 'First name',
		lastName: 'Last name',
		email: 'Email',
		phone: 'Phone',
		language: 'Language',
		changePassword: 'Change Pasword',
		newPassword: 'New Pasword',
		repeatPassword: 'Repeat Password',
		updatePassword: 'Update Password',
		updatedPassword: 'Updated Password',
		passwordAreDifferent: 'Password are different',
		updatedData: 'Updated data',
		changeSass: 'Change platform',
	},
	transportServiceChangeStatus: {
		note: 'Register a quick note*',
		btnUpdate: 'Update Status',
		btnUpdateProcess: 'Processing',
		btnCancel: 'Cancel',
		title: 'Upload Support for new Status',
	},
	transportServiceStatus: {
		pending: 'Pending',
		active: 'Active',
		noShow: 'No show',
		noProvided: 'Not provided',
		canceled: 'Cancelled',
		done: 'Done',
		success: 'Successfully updated service',
		partialCancellation: 'Partial Cancellation',
	},
	filesRelated: {
		emptyImg: 'You haven’t uploaded any images yet',
		fileDelete: 'File deleted',
		notSelectImg: 'You have not selected an image',
		uploadedFile: 'Uploaded file',
	},
	confirm: {
		Yes: true,
		No: false
	},
	statusOptions: {
		active: 'Active',
		pending: 'Pending'
	},
	statusActive: {
		active: 'Active',
		inactive: 'Inactive'
	},
	accessTypes: {
		master: 'Master',
		admin: 'Administrator',
		operation: 'Operation',
		driver: 'Driver',
	},
	langOptions: {
		es: 'Spanish',
		en: 'English',
	},
	alerts: {
		trackingStatusChanged: "The service : {serviceNumber} has been changed to: {trackingStatus} "
	},
	accessDenied: {
		accessDenied: 'Access denied!',
		expiredAccess: 'You no longer have access to this point of sale, you can select another one to continue.',
		onlyOneAccess: 'Your user belongs only to this point of sale',
	},
	login: {
		access: 'Login',
		wrongLogin: 'Wrong username o password',
		forgetPassword: 'Did you forget your password?',
		recoverPassword: 'Recover your password',
		emailSent: 'An email has been sent to your email to recover your password, follow the instructions.',
		updatePassword: 'Update your password',
		repeatPassword: 'Repeat password',
		passwordAreDifferent: 'Passwords are not the same',
		passwordUpdated: 'Your password has been updated',
		requestPasswordExpired: 'The password change request has expired',
	},
	design: {
		mediaPresentation: 'Media & presentation',
		headerLogo: 'Header logo',
		footerLogo: 'Footer logo',
		homeBanner: 'Home banner',
		company: 'Company',
		publicName: 'Public name',
		publicNameDesc: 'Name to be publicly displayed',
		showNewsletter: 'Show newsletter',
		colors: 'Colors',
		primaryColor: 'Main color',
		primaryColorDesc: 'Main font color and icons',
		btnBackgroundColor: 'Button color',
		btnBackgroundColorDesc: 'Button background color',
		btnForegroundColor: 'Button font color',
		btnForegroundColorDesc: 'Button text color',
		backgroundColor: 'Background color',
		backgroundColorDesc: 'General background color',
		example: 'Example:',
		bookHere: 'Book here!',
	},
	taxInformation: {
		taxInformation: 'Tax information',
		company: 'Company',
		address: 'Address',
		city: 'City',
		country: 'Country',
		postalCode: 'Postal code',

	},
	rates: {
		ratesDestinations: 'Destinations & rates',
		salesChannel: 'Sale channel',
		area: 'Area',
		name: 'Name',
		currency: 'Currency',
		action: 'Actions',
		mapTitle: 'Zone visor',
		listTitle: '%{zone} Areas',
		zoneTitle: 'Selected area: ',
		type: 'Type',
		active: 'Active',

	},

	notifications: {
		send: 'Send',
		email: 'Email',
		phone: 'Phone',
		lang: 'Language',
		changeLangClient: 'Change the customer\'s language in the reservation',
		template: 'Template',
		selectOption: 'Select an option',
		previewSms: 'Preview sms',
		characters: 'Characters',
		wantToSendNotification: 'Do you want to send notification?',
		emailWillSentTo: 'The email will be sent to ',
		smsWillSentTo: 'The sms will be sent to ',
		confirm: 'Confirm',
		cancel: 'Cancel',
		selectTemplate: 'Select a template',
		requiredTemplate: 'Notification to be sent is required',
		done: 'Done',
		verifyRequiredFields: 'Verify required fields',

		sendNewNotification: 'Send new notification',
		sendNotification: 'Send notification',
		id: 'Shipment ID',
		status: 'Status',
		creationDatetime: 'Date',
		user: 'User',
		type: 'Type',
		notificationType: 'Notification type',
		dataSource: 'Data source',
		destination: 'Destination',

		// Mail verification notification
		notifications: 'Notifications',
		hasNotification: 'Hi, you have 1 notification!',
		systemSc: 'Shuttle Central System',
		confirmEmail: 'Email Confirmation',
		confirmEmailBody: '<p>Hello {user}, please confirm your email to finish the configuration of your platform and make the most of it.</p><p>We have sent an email to your account for verification.</p>',
		resendEmail: 'Resend email',



	},

	quote: {
		assign: 'Assign',
		title: 'Quotation/Sale',
		reservation: 'Booking',
		newQuote: '/ Quote new reservation',
		currency: 'Currency',
		tripType: 'Type of trip',
		currencyReq: 'Currency is required',
		pickupReq: 'Pickup is required',
		dropoffReq: 'Dropoff is required',
		serviceTypeReq: 'type of service is required',
		dateGoToReq: 'Departure date is required',
		dateGoBackReq: 'Return date is required',
		adultsReq: 'Adults required',
		airportTransp: 'Airport transportation',
		p2p: 'Point to point',
		oneWay: 'One way',
		return: 'Return',
	},

	tooltips: {
		viewRoute: 'View route on map',
		viewLocation: 'View location on map',
		scadmin: 'Direct sale',
		be: 'Service created from booking engine',
		statusPos: 'Your Point of Sale is {status}. Click to change.',
	},

	settings: {
		title: 'Configuration',
		widget: 'Widget',
		tag: 'Tag',
		tagCopy: 'Tag copied!',
		scriptCopy: 'Script copied!',
		scriptDesc: 'Add this script inside the <body>...</body> of your website',
		tagDesc: 'Add this tag in the place where the widget will be displayed',
		save: 'Save changes',
		contact: 'Contact',
		legalName: 'Legal Name',
		legalNameDesc: 'legal name of the company',
		website: 'Web site',
		websiteDesc: 'Example: misitioweb.com.mx',
		phone: 'Contact phone number',
		phoneDesc: 'Customers will contact you by this phone number',
		mail: 'Email notifications',
		mailDesc: 'Notifications will be sent to this email address.',
		addNewMail: 'Add additional email',
		socialMedia: 'Social media',
		fbDesc: 'How to find you via Facebook',
		twDesc: 'How you can be reached via Twitter',
	},

	contact: {
		needHelp: 'Need help with the system?',
		sendWhats: 'Contact via WhatsApp',
		editBooking: 'Do you want to edit a reservation?',
		openChat: 'Open chat',
		openChatDesc: 'Start the chat to receive information and support.',
		defaultMsj1: 'Hi I am ',
		defaultMsj2: ' from ',
		defaultMsj3: ' and I would like to receive help with the admin system.'
	},

	verifyEmail: {
		title: 'Welcome!',
		body: '<p class="mb-4">Thank you for joining {user}! We are very happy you are part of Shuttle Central.</p> <p>Please confirm your email to finish your platform setup.</p>',
		clickToConfirm: 'Click to confirm',
		emailSent: 'Forwarded email, check your inbox',
		confirmedTitle: 'Email confirmed!',
		confirmedBody: 'Thank you for confirming your email, let\'s go back to the system!',
		goBack: 'Go to system',
	}

}
